// REACT
import React from 'react';

// YARN
import { useTranslation } from 'react-i18next';
import EditIcon from '@mui/icons-material/Edit';
import DeleteIcon from '@mui/icons-material/DeleteOutlined';

// INTERFACES
import { ICulture } from 'components/generics/Interface/ICulture';
import { ICultureGroup } from 'components/generics/Interface/ICultureGroup';

type CultureGroupCardParams = {
  cultureGroup: ICultureGroup[];
  onDeleteClick: (groupId: number) => void;
  onEditClick: (groupId: number) => void;
};

const CultureGroupCard = ({ cultureGroup, onDeleteClick, onEditClick }: CultureGroupCardParams) => {
  const { t } = useTranslation();
  return (
    <React.Fragment>
      {cultureGroup ? (
        cultureGroup.map((group) => (
          <div className="cultureGroup-card" key={group.id}>
            <div className="cultureGroup-card__header">
              <h3>{group.name}</h3>
              <div className="cultureGroup-card__header-icons">
                <EditIcon onClick={() => onEditClick(group.id)} />
                <DeleteIcon onClick={() => onDeleteClick(group.id)} />
              </div>
            </div>
            <div className="cultureGroup-card__body">
              <div className="cultureGroup-card__body-subtitle">{t('title.culturesList')}</div>
              <div className="cultureGroup-card__body-list">
                {group.cultures && group.cultures.length > 0 ? (
                  <div>
                    {group.cultures.map((culture: ICulture) => (
                      <p key={culture.id}>• {culture.name}</p>
                    ))}
                  </div>
                ) : (
                  <p>{t('message.noCultureAvailable')}</p>
                )}
              </div>
            </div>
          </div>
        ))
      ) : (
        <p>{t('message.noCultureGroupAvailable')}</p>
      )}
    </React.Fragment>
  );
};

export default CultureGroupCard;
